import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-export-snackbar',
  template: `
    <section class="relative z-auto block h-auto w-auto bg-none">
      <div
        class="h-fit w-fit max-w-xs min-w-[18rem] overflow-hidden rounded-xl border border-gray-200 bg-gray-100/90 shadow-md"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <div
          class="flex h-full w-full animate-pulse items-center gap-3 bg-gray-50 p-4 text-left"
        >
          <div class="m-0 flex flex-shrink-0 justify-center">
            <mat-spinner
              [diameter]="24"
              color="primary"
              aria-hidden="true"
            ></mat-spinner>
          </div>
          <div class="flex-1">
            <h3
              class="m-0 mb-1 text-sm leading-tight font-semibold text-blue-900"
            >
              {{ message }}
            </h3>
            <p class="m-0 text-xs leading-tight text-gray-600">
              {{ details }}
            </p>
          </div>
        </div>
      </div>
    </section>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinnerModule],
})
export class ExportSnackbarComponent {
  @Input() message = 'Exporting...';

  @Input() details = 'Processing data...';
}
